import { useEffect, useRef } from "react";
import { setUserLocation } from "../Redux/locations/action";

const interval = 5 * 60 * 1000;

const useLiveLocation = (props) => {
  const retryTimeoutRef = useRef(null);
  const watchIdRef = useRef(null);
  const lastUpdateTimestampRef = useRef(null);
  const intervalRef = useRef(null);

  const options = {
    enableHighAccuracy: true,
    timeout: 20000,
    maximumAge: 0
  };

  const updateLocation = (position) => {
    if (!position) {
      return setUserLocation(null);
    }
    const newLocation = {
      latitude: position.coords.latitude,
      longitude: position.coords.longitude
    };

    lastUpdateTimestampRef.current = Date.now();

    setUserLocation({
      latitude: newLocation.latitude,
      longitude: newLocation.longitude
    });
  };

  const forceFetchLocation = () => {
    navigator.geolocation.getCurrentPosition(
      (position) => {
        updateLocation(position);
      },
      (error) => {
        console.error("Force location fetch error", error);
        return updateLocation(null);
      },
      options
    );
  };

  const successCallback = (position) => {
    updateLocation(position);
  };

  const errorCallback = (error) => {
    console.error("Location error", error);

    if (error.code === 3 || error.code === 2) {
      retryTimeoutRef.current = setTimeout(() => {
        navigator.geolocation.getCurrentPosition(
          successCallback,
          errorCallback,
          options
        );
      }, 10000);
    }
  };

  useEffect(() => {
    if (!props.isAuth || !props.isLocationPermissionGranted) {
      return;
    }

    navigator.geolocation.getCurrentPosition(
      successCallback,
      errorCallback,
      options
    );

    watchIdRef.current = navigator.geolocation.watchPosition(
      successCallback,
      errorCallback,
      options
    );

    intervalRef.current = setInterval(() => {
      const now = Date.now();
      if (
        !lastUpdateTimestampRef.current ||
        now - lastUpdateTimestampRef.current > interval
      ) {
        forceFetchLocation();
      }
    }, interval / 10);

    return () => {
      if (watchIdRef.current) {
        navigator.geolocation.clearWatch(watchIdRef.current);
      }
      if (retryTimeoutRef.current) {
        clearTimeout(retryTimeoutRef.current);
      }
      if (intervalRef.current) {
        clearInterval(intervalRef.current);
      }
    };
    // eslint-disable-next-line
  }, [props.isAuth, props.isLocationPermissionGranted]);
};

export default useLiveLocation;
